export default __webpack_public_path__ + "static/funnel-light-737078edaf32dfef6cdb4825b707cd52.png";